import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Button, Sprite } from '@agissc/ktag-map';

interface ToolbarItemProps {
  additionalClassNames?: string;
  label?: string;
  icon: string;
  title?: string;
  isActive?: boolean;
  children?: ReactNode;
  disabled?: boolean;
  badge?: string;
  onClick: () => void;
}

const ToolbarItem = ({
  additionalClassNames,
  label,
  icon,
  title,
  isActive = false,
  children,
  disabled,
  badge,
  onClick,
}: ToolbarItemProps) => {
  return (
    <li className={classNames('toolbar__item', additionalClassNames)} title={title}>
      {children}
      <Button
        disabled={disabled}
        additionalClassNames={classNames('toolbar__item-button', {
          'toolbar__item-button--active': isActive,
        })}
        onClick={onClick}
      >
        <Sprite additionalClassNames="toolbar__item-icon" id={icon} title={title} />
        {badge && (
          <span key={badge} className="toolbar__item-badge">
            {badge}
          </span>
        )}
        {label && <span className="toolbar__item-label">{label}</span>}
      </Button>
    </li>
  );
};

export default ToolbarItem;
